import { Type } from '@sinclair/typebox';
import { OwnerProfileSchema } from './owner-profile.js';
export const FirstBuyerGroups = [
    'buy-more',
    'holder',
    'sell-all',
    'sell-part',
];
export const FirstBuyerSchema = Type.Object({
    maker: Type.String(),
    group: Type.Union([
        Type.Literal('buy-more'),
        Type.Literal('holder'),
        Type.Literal('sell-all'),
        Type.Literal('sell-part'),
    ]),
    isSniper: Type.Boolean(),
    owner: Type.Optional(OwnerProfileSchema),
});
//# sourceMappingURL=first-buyer.js.map